import { combineReducers } from 'redux';
import Auth from '../appRedux/reducers/Auth';
import Common from '../appRedux/reducers/Common';
import Settings from '../appRedux/reducers/Settings';
import userLoginApiSlice from './features/auth/UserLogin';
import { chatPostReducer } from './chatApp/chatPostSlice';
import { userLogoutApiReducer } from './features/auth/UserLogout';
import { ForgotPasswordApiSlice } from './features/auth/ForgotPassword';
import { ChangePasswordApiSlice } from './features/auth/ChangePassword';
import { VerifyOtpApiSlice } from './features/auth/VerifyOTP';
import { getTokenSpeechApiReducer } from './chatApp/tokenSpeech';
import { HistoryChatsReducer } from './chatApp/HistoryChat';
import { NewChatReducer } from './chatApp/NewChat';
import { specificChatReducer } from './chatApp/SpecificChat';
import { chatFeedbackReducer } from './chatApp/chatFeedbackSlice';
import { editSliceReducer } from './chatApp/chatEditSlice';
import { renameSliceReducer } from './chatApp/renameChatSlice';
import { InfluencerVerifyOtpApiSlice } from './features/auth/InfluencerVerifyOTP';

export default combineReducers({
	settings: Settings,
	auth: Auth,
	common: Common,
	userLoginApi: userLoginApiSlice,
	userLogoutApi: userLogoutApiReducer,
	chatPostReducer: chatPostReducer,
	getTokenSpeechApiReducer: getTokenSpeechApiReducer,
	forgotPassword: ForgotPasswordApiSlice,
	changePassword: ChangePasswordApiSlice,
	verifyOtp: VerifyOtpApiSlice,
	HistoryChatsReducer:HistoryChatsReducer,
	NewChatReducer:NewChatReducer,
	specificChatReducer:specificChatReducer,
	chatFeedbackReducer:chatFeedbackReducer,
	editSliceReducer:editSliceReducer,
	renameSliceReducer:renameSliceReducer,
	influencerVerifyOtp: InfluencerVerifyOtpApiSlice,
});
